// src/hooks/useProducts.ts
import { useQuery } from "@tanstack/react-query";
import getProducts from "@/api/getProducts";
import type { Products } from "@/types";

const useProducts = (searchQuery?: string) => {
  const {
    data: products = [],
    isLoading: loading,
    isError,
    error,
    refetch,
  } = useQuery<Products[], Error>({
    queryKey: ["products", searchQuery || ""], // unique cache per search term
    queryFn: () => getProducts(searchQuery),
    staleTime: 1000 * 60 * 5, // cache valid for 5 minutes
    refetchOnWindowFocus: false, // avoid refetching when switching tabs
  });

  return {
    products,
    loading,
    error: isError ? error.message : null,
    refetch, 
  };
};

export default useProducts;
